export const promiseWithMinDelay = async (promise, minDelay = 500) => {
  const [result] = await Promise.all([
    promise,
    new Promise((resolve) => setTimeout(resolve, minDelay)),
  ]);
  return result;
};
